import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Table,
  Form,
  FormGroup,
  Input,
  Button,
} from "reactstrap";

import { API_BASE_URL } from "../config/api";

const API_BASE = API_BASE_URL;

function Contact() {
  const [contacts, setContacts] = useState([]);
  const [locations, setLocations] = useState([]);

  const [newContact, setNewContact] = useState({ phone: "", email: "", contact_link: "" });
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const [selectedContactId, setSelectedContactId] = useState(null);
  const [updateContact, setUpdateContact] = useState({ phone: "", email: "", contact_link: "" });

  const [newLocation, setNewLocation] = useState({ location_url: "" });
  const [showLocationUpdateForm, setShowLocationUpdateForm] = useState(false);
  const [selectedLocationId, setSelectedLocationId] = useState(null);
  const [updateLocation, setUpdateLocation] = useState({ location_url: "" });

  const fetchContacts = async () => {
    try {
      const response = await axios.get(`${API_BASE}/contact/list`);
      if (response.data && response.data.success) {
        setContacts(response.data.data || []);
      } else {
        console.error("Unexpected response format:", response.data);
      }
    } catch (error) {
      console.error("Error fetching contacts:", error);
    }
  };

  const fetchLocations = async () => {
    try {
      const response = await axios.get(`${API_BASE}/location/list`);
      if (response.data && response.data.success) {
        setLocations(response.data.data || []);
      } else {
        console.error("Unexpected response format:", response.data);
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
    }
  };

  useEffect(() => {
    fetchContacts();
    fetchLocations();
  }, []);

  const handleContactInputChange = (e) => {
    const { name, value } = e.target;
    setNewContact({ ...newContact, [name]: value });
  };

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_BASE}/contact/add`, newContact);
      setNewContact({ phone: "", email: "", contact_link: "" });
      fetchContacts();
    } catch (error) {
      console.error("Error adding contact:", error);
    }
  };

  const handleContactDelete = async (contactId) => {
    try {
      await axios.delete(`${API_BASE}/contact/delete/${contactId}`);
      setContacts((prev) => prev.filter((c) => c.id !== contactId));
    } catch (error) {
      console.error("Error deleting contact:", error);
    }
  };

  const handleContactUpdate = (contact) => {
    setSelectedContactId(contact.id);
    setUpdateContact({
      phone: contact.phone || "",
      email: contact.email || "",
      contact_link: contact.contact_link || "",
    });
    setShowUpdateForm(true);
  };

  const handleContactUpdateSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${API_BASE}/contact/update/${selectedContactId}`, updateContact);
      setShowUpdateForm(false);
      setSelectedContactId(null);
      setUpdateContact({ phone: "", email: "", contact_link: "" });
      fetchContacts();
    } catch (error) {
      console.error("Error updating contact:", error);
    }
  };

  const handleLocationInputChange = (e) => {
    const { name, value } = e.target;
    setNewLocation({ ...newLocation, [name]: value });
  };

  const handleLocationSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_BASE}/location/add`, newLocation);
      setNewLocation({ location_url: "" });
      fetchLocations();
    } catch (error) {
      console.error("Error adding location:", error);
    }
  };

  const handleLocationDelete = async (locationId) => {
    try {
      await axios.delete(`${API_BASE}/location/delete/${locationId}`);
      setLocations((prev) => prev.filter((c) => c.id !== locationId));
    } catch (error) {
      console.error("Error deleting location:", error);
    }
  };

  const handleLocationUpdate = (item) => {
    setSelectedLocationId(item.id);
    setUpdateLocation({ location_url: item.location_url || "" });
    setShowLocationUpdateForm(true);
  };

  const handleLocationUpdateSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${API_BASE}/location/update/${selectedLocationId}`, updateLocation);
      setShowLocationUpdateForm(false);
      setSelectedLocationId(null);
      setUpdateLocation({ location_url: "" });
      fetchLocations();
    } catch (error) {
      console.error("Error updating location:", error);
    }
  };

  return (
    <div className="content">
      <Row>
        <Col md="12">
          <Card>
            <CardHeader>
              <CardTitle tag="h4">Contact</CardTitle>
            </CardHeader>
            <CardBody>
              {/* <Form onSubmit={handleContactSubmit}>
                <FormGroup>
                  <label>Phone</label>
                  <Input
                    type="text"
                    name="phone"
                    placeholder="+962..."
                    value={newContact.phone}
                    onChange={handleContactInputChange}
                  />
                </FormGroup>
                <FormGroup>
                  <label>Email</label>
                  <Input
                    type="text"
                    name="email"
                    placeholder="example@email.com"
                    value={newContact.email}
                    onChange={handleContactInputChange}
                  />
                </FormGroup>
                <FormGroup>
                  <label>Website</label>
                  <Input
                    type="text"
                    name="contact_link"
                    placeholder="https://..."
                    value={newContact.contact_link}
                    onChange={handleContactInputChange}
                  />
                </FormGroup>
                <Button color="primary" type="submit">Add Contact</Button>
              </Form> */}

              <Table className="mt-4">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Phone</th>
                    <th>Email</th>
                    <th>Website</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {contacts.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.phone}</td>
                      <td>{item.email}</td>
                      <td>{item.contact_link}</td>
                      <td>
                        <Button color="secondary" onClick={() => handleContactUpdate(item)}>Update</Button>{" "}
                        <Button color="danger" onClick={() => handleContactDelete(item.id)}>Delete</Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              {showUpdateForm && (
                <Form onSubmit={handleContactUpdateSubmit}>
                  <FormGroup>
                    <label>Update Phone</label>
                    <Input
                      type="text"
                      name="phone"
                      value={updateContact.phone}
                      onChange={(e) => setUpdateContact({ ...updateContact, phone: e.target.value })}
                    />
                  </FormGroup>
                  <FormGroup>
                    <label>Update Email</label>
                    <Input
                      type="text"
                      name="email"
                      value={updateContact.email}
                      onChange={(e) => setUpdateContact({ ...updateContact, email: e.target.value })}
                    />
                  </FormGroup>
                  <FormGroup>
                    <label>Update Website</label>
                    <Input
                      type="text"
                      name="contact_link"
                      value={updateContact.contact_link}
                      onChange={(e) => setUpdateContact({ ...updateContact, contact_link: e.target.value })}
                    />
                  </FormGroup>
                  <Button color="primary" type="submit">Update</Button>{" "}
                  <Button color="secondary" onClick={() => setShowUpdateForm(false)}>Cancel</Button>
                </Form>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col md="12">
          <Card>
            <CardHeader>
              <CardTitle tag="h4">Location</CardTitle>
            </CardHeader>
            <CardBody>
              {/* <Form onSubmit={handleLocationSubmit}>
                <FormGroup>
                  <label>Location URL</label>
                  <Input
                    type="text"
                    name="location_url"
                    placeholder="https://maps.app.goo.gl/..."
                    value={newLocation.location_url}
                    onChange={handleLocationInputChange}
                  />
                </FormGroup>
                <Button color="primary" type="submit">Add Location</Button>
              </Form> */}

              <Table className="mt-4">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Location URL</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {locations.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.location_url}</td>
                      <td>
                        <Button color="secondary" onClick={() => handleLocationUpdate(item)}>Update</Button>{" "}
                        <Button color="danger" onClick={() => handleLocationDelete(item.id)}>Delete</Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              {showLocationUpdateForm && (
                <Form onSubmit={handleLocationUpdateSubmit}>
                  <FormGroup>
                    <label>Update Location URL</label>
                    <Input
                      type="text"
                      name="location_url"
                      value={updateLocation.location_url}
                      onChange={(e) => setUpdateLocation({ location_url: e.target.value })}
                    />
                  </FormGroup>
                  <Button color="primary" type="submit">Update</Button>{" "}
                  <Button color="secondary" onClick={() => setShowLocationUpdateForm(false)}>Cancel</Button>
                </Form>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Contact;
